import { getCookie, setCookie, changeEmbedWarning, enableEmbeds, enableDataDiv, initForm, getParents, getOuterHeight, getHeight, nextByClass } from './helpers';

/**
 * Rewriting Eagerly_Tools_Cookie to a class
 * @param {Object} options
 * @returns
 */
export default class Eagerly_Tools_Cookie {
	constructor(options) {
		this.options = options;
		this.firstLoaded = false;
		this.initialSettings = cookieData.initialSettings || null;
		this.cookie = {
			$container: false,
			$containerIntro: false,
			$overlay: false,
			$btn: false,
			$replacementBtn: false,
			active: false,
			settings: '',
			initIntro: true,
		};
	}

	/**
   * On init and a user change in cookies, retrieve the right elements that need adjustments
   * @updates constructors
   */
	setHTMLElements() {
		this.cookie.$container = document.getElementById('eagerly-tools-cookie');
		this.cookie.$containerIntro = document.getElementById('eagerly-tools-cookie-intro');
		this.cookie.$overlay = document.getElementById('eagerly-tools-cookie-overlay');
		this.cookie.$btn = document.querySelectorAll('.js-cookie-btn');
		this.cookie.$replacementBtn = document.querySelectorAll('.js-cookie-replacement-btn');
		this.cookie.$acceptAllIntro = document.getElementById('cookie-accept-intro');
		this.cookie.$acceptAll = document.getElementById('cookie-accept');
		// this.cookie.$privacyLink = document.getElementById('privacy');
		// this.cookie.$privacyLinkIntro = document.getElementById('privacy-link-intro');
	}

	/**
   * Compares the checkboxes with the cookie settings
   * @sets js-cookie-field
   */
	addSettingsClasses() {
		document.querySelectorAll('.js-cookie-checkbox-group input').forEach((item) => {
			if (this.cookie.settings && this.cookie.settings.indexOf(item.value) > -1) {
				item.checked = true;
				item.closest('.js-cookie-field').classList.add('checked');
			}
		});
	}

	/**
   * Opens cookie menu and add all interactivity
   * @sets classnames and event listeners
   */
	openCookie() {
		// TODO: opening the cookie basically recreates it. Maybe more efficient/clear if its seperated?
		if (!this.cookie.active) {
			typeof this.options.before === 'function' && this.options.before.call(this.cookie.$container, 'open');
			this.cookie.active = true;
			this.cookie.$overlay.style.display = 'block';
			this.cookie.$acceptAll.focus();

			if (this.cookie.initIntro && this.cookie.$containerIntro) {
				this.cookie.$containerIntro.classList.remove('hide-mob');
			} else {
				this.cookie.$container.classList.remove('hide-mob');
				// set max height scroller:
				const cookieFbTop = document.getElementsByClassName('js-cookie-fb-top');
				const cookieFbBottom = document.getElementsByClassName('js-cookie-fb-top');
				const h = window.innerHeight - getOuterHeight(cookieFbTop, true) - getOuterHeight(cookieFbBottom, true);
				document.querySelectorAll('.js-cookie-fb-scroller').forEach((e) => {
					e.style.maxHeight = h + 'px';
				});
			}


			if (this.cookie.initIntro && this.cookie.$containerIntro) {
				this.cookie.$containerIntro.classList.add('active');
				this.cookie.$acceptAllIntro.focus();
			} else {
				this.cookie.$container.classList.add('active');
				this.cookie.$acceptAll.focus();
			}

			this.cookie.initIntro = false;

			// Close button (x) in modal
			const btnClose = document.querySelectorAll('.js-close-cookie');
			btnClose.forEach((btn) => {
				btn.addEventListener('keyup', (event) => {
					if (event.key === 'Enter') {
						btn.click();
					}
				});
			});

			// Ok button in modal
			const btnOk = document.querySelectorAll('.js-btn-ok');
			btnOk.forEach((btn) => {
				btn.addEventListener('keyup', (event) => {
					if (event.key === 'Enter') {
						btn.click();
					}
				});
			});
		}
	}

	/**
   * Closes cookie menu and sets cookie activity to false
   * @param {Boolean} switchPopup if true, we switch from small, initial popup to bigger one
   * @sets classnames, constructors and calls saveCookie
   */
	closeCookie(switchPopup) {
		if (this.cookie.active) {
			typeof this.options.before === 'function' && this.options.before.call(this.cookie.$container, 'close');
			this.cookie.active = false;
			if (!switchPopup) {
				this.cookie.$overlay.classList.remove('active');
			}
			// If we're in the intro remove the intro active class
			if (this.cookie.$containerIntro && this.cookie.$containerIntro.classList.contains('active')) {
				this.cookie.$containerIntro.classList.remove('active');
			} else {
				// Otherwise remove the active class from the cookie container
				this.cookie.$container.classList.remove('active');
			}
			setTimeout(() => {
				if (!switchPopup) {
					this.cookie.$overlay.style.display = 'none';
					this.cookie.$container.classList.add('hide-mob');
				}
				typeof this.options.after === 'function' && this.options.after.call(this.cookie.$container, 'close');
			}, 250);
		}
		if (!switchPopup) {
			this.saveCookie();
		}
	}

	/**
   * Saves current cookie settings to DOM and Google Tag Manager
   * Activates other functions with settings and sets new settings
   */
	saveCookie() {
		const newSettings = [],
			prevSettings = this.cookie.settings;
		this.cookie.$container.querySelectorAll('.js-cookie-fb-scroller input:checked').forEach((item) => {
			newSettings.push(item.value);
		});
		setCookie('cookie_settings', newSettings, true);
		this.cookie.settings = newSettings.join(',');
		this.updateDOM(prevSettings);
		this.doGTMEvents(prevSettings);
	}

	/**
   * Open sub menu when clicking a cookie option
   * @sets styling
   */
	openSub() {
		// `this` is the element
		const element = this;
		if (globalThis.eagerly_cookie_instance.cookie.active) {
			const h = getHeight(nextByClass(element, 'js-cookie-item-content'));
			const items = getParents(element, 'js-cookie-checkbox-group');
			items.forEach((item) => {
				if (item.classList.contains('active')) {
					item.classList.remove('active');
					item.style.height = 60 + 'px';
				} else {
					item.classList.add('active');
					item.style.height = 60 + h + 'px';
					for (let sibling of item.parentNode.children) {
						if (sibling !== item && sibling.classList.contains('js-cookie-checkbox-group')) {
							sibling.classList.remove('active');
							sibling.style.height = 60 + 'px';
						}
					}
				}
			});
		}
	}

	/**
   * Actication of a cookie option
   * @sets open or close cookie event listeners
   */
	clicksCookie() {
		this.setHTMLElements();
		this.cookie.$replacementBtn &&
		this.cookie.$replacementBtn.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				this.cookie.active ? this.closeCookie(false) : this.openCookie();
			});
		});
		this.cookie.$btn &&
		this.cookie.$btn.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				if (!this.cookie.active) this.openCookie();
			});
			btn.addEventListener('keyup', (event) => {
				if (event.key === 'Enter') {
					btn.click();
				}
			});
		});
		this.cookie.$container &&
		this.cookie.$container.querySelectorAll('.js-close-cookie,.js-btn-ok').forEach((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();
				this.closeCookie(false);
			});
		});
		this.cookie.$containerIntro &&
		this.cookie.$containerIntro.querySelectorAll('.js-close-cookie,.js-btn-ok-big').forEach((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();
				this.cookie.active && this.closeCookie(false);
			});
		});
		this.cookie.$containerIntro &&
		this.cookie.$containerIntro.querySelectorAll('.js-btn-change').forEach((item) => {
			item.addEventListener('click', (e) => {
				e.preventDefault();
				if (this.cookie.active) {
					this.closeCookie(true);
					this.openCookie();
				}
			});
		});
		this.cookie.$overlay.addEventListener('click', () => {
			this.closeCookie(false);
		});
		document.querySelectorAll('.js-open-cookie-item').forEach((item) => {
			item.addEventListener('click', this.openSub); // Keep reference to function so it doesn't create multiple event listeners
		});

		document.querySelector('.js-btn-accept-all').addEventListener('click', () => {
			document.querySelectorAll('.js-cookie-fb-scroller .js-cookie-checkbox-group:not(.disabled)').forEach((subItem) => {
				subItem.classList.add('checked');
				subItem.querySelector('input').checked = true;
				setTimeout(() => {
					this.closeCookie(false);
				}, 250);
			});
		});

		document.querySelectorAll('.js-cookie-fb-scroller .js-cookie-checkbox-group input').forEach((item) => {
			item.dispatchEvent(new Event('change'));
		});
	}

	/**
   * Adding methods that can be adjusted by custom later
   */
	enableStatistics() {}
	enableYouTube() {}
	disableYouTube() {}
	enableScript() {}
	enableFacebook() {}
	enableTwitter() {}
	enableLinkedin() {}
	enableShare() {}

	consentGrantedAnalytics() {
		if ( typeof gtag != 'undefined' ){
			gtag('consent', 'update', {
				'analytics_storage': 'granted'
			});
		}
	 }

	consentGrantedAdStorage() {
		if ( typeof gtag != 'undefined' ){
			gtag('consent', 'update', {
				'ad_storage': 'granted',
				'ad_user_data': 'granted',
				'ad_personalization': 'granted',
				'analytics_storage': 'granted'
			});
		}
	 }


	updateDOM(previousSettings) {
		if (this.cookie.settings) {
			let settings = this.cookie.settings;

			if (previousSettings && previousSettings === settings) {
				this.debug('no change!');
				return false;
			}

			settings = settings.split(',');
			previousSettings = previousSettings ? previousSettings.split(',') : settings;

			if (settings.length < previousSettings.length || (settings.length > previousSettings.length && 1 == cookieData.forceReload)) {
				// NOTE: reload page to unload API's
				if (!this.firstLoaded) window.location.reload();
			} else if (settings.length === 1) {
				this.debug(settings);
				this.disableYouTube();
				enableEmbeds(['functional']);
			} else {
				// NOTE: load specific API's
				for (const key in settings) {
					this.debug(settings[key]);

					switch (settings[key]) {
					case 'tracking':
						this.enableYouTube();
						this.enableShare();
						enableEmbeds(['tracking']);
						this.enableScript();
						enableDataDiv();
						this.enableFacebook();
						this.enableTwitter();
						this.enableLinkedin();
						break;
					case 'settings':
					case 'statistics':
						this.enableStatistics();
						break;
					case 'other':
						break;
					}
				}
			}
		}
	}

	doGTMEvents(prevSettings) {
		if (this.cookie.settings) {
			let settings = this.cookie.settings;

			if ('' != prevSettings && prevSettings === settings) {
				this.debug('GTM: no change!');
				return false;
			}

			settings = settings.split(',');
			window.dataLayer = window.dataLayer || [];
			let doDefaultOnlyEvent = true;

			for (const key in settings) {
				if (settings[key] != 'default') {
					doDefaultOnlyEvent = false;
				}
				this.debug('GTM push event: "eagerly_cookie_' + settings[key] + '"');
				if (settings[key] == 'tracking') {
					this.consentGrantedAdStorage();
				}
				window.dataLayer.push({
					event: 'eagerly_cookie_' + settings[key],
				});
			}

			if (doDefaultOnlyEvent) {
				this.consentGrantedAnalytics();
				window.dataLayer.push({
					event: 'eagerly_cookie_onlydefault',
				});
			}
		}
	}

	newElementObsever(selector) {
		return new Promise((resolve, reject) => {
			let el = document.querySelector(selector);
			if (el) {
				resolve(el);
				return;
			}
			new MutationObserver((mutationRecords, observer) => {
				Array.from(document.querySelectorAll(selector)).forEach((element) => {
					resolve(element);
					observer.disconnect();
				});
			})
				.observe(document.documentElement, {
					childList: true,
					subtree: true
				});
		});
	}

	init() {
		if (!getCookie('cookie_settings')) {
			this.firstLoaded = true;
			setCookie('cookie_settings', this.initialSettings.join(','), true);
			this.cookie.settings = this.initialSettings.join(',');
		}
		changeEmbedWarning();

		this.setHTMLElements();
		this.cookie.settings = getCookie('cookie_settings');
		this.addSettingsClasses();
		this.updateDOM('');
		this.doGTMEvents('');
		this.clicksCookie();

		if (this.firstLoaded) {
			this.cookie.initIntro = true;
			this.firstLoaded = false;
			this.cookie.$container.classList.add('first');
			this.cookie.$overlay.classList.add('active');
			this.cookie.$btn[0].click();
		} else {
			this.cookie.initIntro = false;
			this.cookie.$container.classList.remove('first');
			this.cookie.$overlay.classList.remove('active');
			this.cookie.$container.removeAttribute('style');
		}

		initForm();

		setTimeout(function() {
			document.getElementById('eagerly-tools-cookie-btn').style.opacity = 1;
		}, 250);
	}

	debug(message) {
		if (this.options.debug) console.log(message);
	}
}

/**
 * Function creating an instance of Eagerlt_Tools_Cookie
 * @param
 * @returns
 */
function domReady() {
	document.removeEventListener('DOMContentLoaded', domReady);
	const eagerly_cookie = new Eagerly_Tools_Cookie({
		//TODO: where is eagerly_cookie created and how do we return it
		debug: false,
		//root : '/includes/cookie',
		before: function(stat) {
			//console.log(stat);
			// voor bijvoorbeeld lock scroll
			// eagerly_cookie.cookie.clicks();
		},
		after: function(stat) {
			//console.log(stat);
			// voor bijvoorbeeld unlock scroll
		},
	});
	eagerly_cookie.init();
	eagerly_cookie.newElementObsever('.js-cookie-btn').then(() => {
		eagerly_cookie.init();
	});
	globalThis.eagerly_cookie_instance = eagerly_cookie;
}

document.addEventListener('DOMContentLoaded', domReady);
